// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"a368a03e","683":"1e03361e","743":"b0e28626","876":"559b0e11","958":"574c6813"}[chunkId] + ".chunk.css";
};